/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Status_Not_SyncedInputs */

const en_sync_status_not_synced = /** @type {(inputs: Sync_Status_Not_SyncedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not sent`)
};

/**
* | output |
* | --- |
* | "Not sent" |
*
* @param {Sync_Status_Not_SyncedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sync_status_not_synced = /** @type {((inputs?: Sync_Status_Not_SyncedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Status_Not_SyncedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sync_status_not_synced(inputs)
});